import BillAuthorModel from './bill_author_model';
export default Backbone.Collection.extend({
  model: BillAuthorModel
});